import { render, staticRenderFns } from "./newBillOverseasSAcceptView.vue?vue&type=template&id=06b82e6c&"
import script from "./newBillOverseasSAcceptView.vue?vue&type=script&lang=js&"
export * from "./newBillOverseasSAcceptView.vue?vue&type=script&lang=js&"
import style0 from "./newBillOverseasSAcceptView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b82e6c')) {
      api.createRecord('06b82e6c', component.options)
    } else {
      api.reload('06b82e6c', component.options)
    }
    module.hot.accept("./newBillOverseasSAcceptView.vue?vue&type=template&id=06b82e6c&", function () {
      api.rerender('06b82e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/newBillOverseasSAcceptView.vue"
export default component.exports